// src/supabaseClient.js

import { createClient } from '@supabase/supabase-js';

// URL de tu proyecto de Supabase
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;

// Clave anónima (anon key) de tu proyecto
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Verifica que las variables de entorno estén definidas
if (!supabaseUrl) {
  console.error("❌ VITE_SUPABASE_URL no está definida en el archivo .env");
  throw new Error("Falta la URL de Supabase. Verifica tu archivo .env");
}

if (!supabaseAnonKey) {
  console.error("❌ VITE_SUPABASE_ANON_KEY no está definida en el archivo .env");
  throw new Error("Falta la clave anónima de Supabase. Verifica tu archivo .env");
}

// Crea el cliente de Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Opcional: Muestra un mensaje en consola cuando se inicializa
console.log("✅ Cliente de Supabase inicializado correctamente.");